export default __webpack_public_path__ + "static/media/KZ.Т.12.2480.921b8638.svg";